import { Navigate, useParams } from 'react-router-dom';

/**
 * Keeps the old one-outcode links working.
 *
 * <p>`/area/N10` was a screen of its own before the criteria moved into the URL. Links to it exist
 * in the report and in the address list, and somebody may have bookmarked one, so it now redirects
 * to the same search rather than becoming a second screen to keep in step with the first.
 */
export default function AreaRedirectPage() {
  const { outcode = '' } = useParams<{ outcode: string }>();
  const code = outcode.trim().toUpperCase();
  return <Navigate to={code ? `/areas?outcodes=${encodeURIComponent(code)}` : '/areas'} replace />;
}
